import { Component } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzResultModule } from 'ng-zorro-antd/result';
import { Router } from '@angular/router';

@Component({
  selector: 'app-access-denied',
  standalone: true,
  imports: [NzButtonModule, NzResultModule],
  template: `
    <nz-result
      nzStatus="403"
      nzTitle="403"
      nzSubTitle="Sorry, you do not have access to this page."
    >
      <div nz-result-extra>
        <button nz-button nzType="primary" (click)="goToHome()">Back Home</button>
      </div>
    </nz-result>
  `,
})
export class AccessDeniedComponent {
  constructor(private router: Router) {}

  goToHome(): void {
    this.router.navigate(['']);
  }
}
